import gql from 'graphql-tag'

export const main = gql`
	fragment cashRegisterMain on CashRegister {
		parameters {
			phone
			street
			city
			postCode
			companyName
			additionName
			vatNumber
			optional1
			optional2
			autoCloseBill
			advertisingText
			country
			language
			printer {
				autoPrintBills
				notPrintRFIDBills
				printBillFromAmount
			}
			loginMode
			loyaltyProdItemId
			loyaltyProdItemIdOp2
			loyaltyProdItemIdOp3
			loyaltyProdItemIdOp4
			loyaltyProdItemIdOp5
			employeeLoyaltyProductId
			smsNotificationPhoneNumbers
		}
	}
`

export const kasse = gql`
	fragment cashRegisterKasse on CashRegister {
		parameters {
			reducedVat
			normalVat
			specialVat
			isInCafeModeInt
			isInCafeMode
			isInCafeModeDefault
			isActiveTimeAssist
			loginOnlyAfterTimeRecording
			logoutOnlyAfterTimeRecording
			apaleoPmsProperty
			pmsType
			pmsProtelIP
			pmsProtelPort
			nonGuestTransfer
			pmsAutoPrintBills
			creditCards {
				clientButtonName {
					value
					position
				}
				startPiecemeal {
					value
					position
				}
				isPiecemeal {
					value
					position
				}
				receiptCopies {
					value
					position
				}
			}
			discountForm {
				button1
				buttonName1
				button2
				buttonName2
				button3
				buttonName3
				button4
				buttonName4
				button5
				buttonName5
			}
			isDiscountFormDisabled
			drawerCloseCheck
			hideOpenDrawerBtn
			isDrawerOpenDuringClosing
			isReturnButtonDeleted
			designProject
			restaurantIsMainMode
			restaurantDefaultRoom
			restaurantBirdViewActive
			isHospitalityReceiptEnabled
			isInCafeConfirmationBeforePayment
			serviceCallMode
			retrieveNumberOfGuests
			closingType
			isEmployeeClosingActive
			priceLevelForm {
				timeInterval {
					from
					to
				}
				priceLevel {
					normal
					inCafe
				}
				weekDays
			}
			isSellProductInWorkingTime
			foreignCurrency {
				euro {
					roundTo
					changeTo
					exchangeRateIsUsed
					additionPercent
					isEuroCoinsNotShown
					is200EuroNotShown
					isShowTotalEuroOnCustomerDisplay
					isActive
					isDefinedMannualy
				}
			}
			itemLoyaltyCard
			activateTipFunction
			egumaCreditId
			isEgumaActive
			guradoCreditId
			isGuradoActive
			preoderPrepaidProduct
			preoderPickupProduct
		}
	}
`

export const hardware = gql`
	fragment cashRegisterHardware on CashRegister {
		installVersion
		parameters {
			printer {
				name
				ip
				labelTitle
				isPrintEFTReceipts
				connectionType
				printCartQR
				separateKitchenBill
        		topMargin
				defaultLabelID
				automaticLabelPrint
				isKitchenPrinterActive
				isPrintKitchenBillAfterCompletionOnly
				isPrintKitchenBillForTableOnly
				locations {
					position
					isActive
					ip
					isDirectConnected
					ipDeviceLabel
					copyForWaiter
					tableShiftReceipt
				}
			}
			builtInFonts
			localIPAdress
			hasBarcodeByReceiptTotal
			paymentTerminal {
				id
				serialNumber
				posId
				ip
				port
				sumUpEmail
				sumUpPassword
				creditPositionInfo {
					position
				}
				walleeApplicationKey
				walleeVirtualTerminalId
				walleeUserId
				walleeSpaceId
				walleeTerminalID
			}
			gloryTerminalConnected
			gloryTerminalAddress
			gloryTerminalUser
			gloryTerminalPassword
			categoryFont{
				fontName
				size
			}
			productFont{
				fontName
				size
			}
			autoCloseBill
			autoSelectFirstCategory
			categoryGridX
			categoryGridY
			specialDesignType
			cardTextColor
			isMainScreenWithVideo
			accentColor
			hasFastLine
			multiLanguage
			mainScreenLogo
			paymentBackgroundImg
			loyaltyCardImg
			loyaltyCardIcon
			takeOutImg
			inCafeImg
			settingsPassword
			showOrderViewKiosk
			useOldDesign
			logo {
				img {
					uid
					key
				}
			}
			disallowLoyaltyCards
			closingTime
			displayEitherCategoriesOrProducts
			idleMinutesBeforeLock
			displayArticle
			scale
			scaleDisplayAlwaysVisible
			isQRCodeBillEnabled
			weightTara {
				names {
					value
					position
				}
				values {
					value
					position
				}
				isAutoSelect {
					value
					position
				}
			}
			tseIsActive
			tseType
			tseAdminPin
			tseAdminPuk
			tseTimeAdminPin
			tseTimeAdminPuk
			tseEpsonIp
			tsePrintQRCode
			isCashierHasManyDrawers
		}
		isSynced
		deviceIdentity {
			hardwareId
			clientType
			eloviewId
		}
		status
		tseRemoteCashRegisterId
		tseInfo {
			info
			expirationDate
      }
	}
`

export const general = gql`
	fragment cashRegisterGeneral on CashRegister {
		shopId
		name
		priceLevelIn
		priceLevelOut
		mode
	}
`

export const external = gql`
	fragment cashRegisterExternal on CashRegister {
		clientNumber
		externToolBox
		filial
	}
`

export const openingHours = gql`
	fragment openingHours on Shop {
		openingHours {
			id: flag
			timeSlot
			description
			day
			openingTime {
				from
				to
			}
			lunchBreak {
				from
				to
			}
		}
	}
`

export const accountingData = gql`
	fragment accountingData on Shop {
		clientNum
		costCentre
		passAccount
		cashRegisterAccount
		taxAccount
		taxCode
		compensateDayDifference
		noExportPassAccount
		credit
		outcome
		additionalCurrencies
		euroInCHF
		loyaltyCardRef
		loyaltyCardTopUp
		loyaltyCardDiscount
	}
`

